import React from "react";

import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";

import { CustomLoeschenContainer } from "./components/CustomLoeschenContainer";
import { StammdatenFormEngine } from "./components/StammdatenFormEngine";
import { StammdatenOverviewEngine } from "./components/StammdatenOverviewEngine";
import { setStammdatenReadonlyMiddleware } from "./middlewares/setStammdatenReadonlyMiddleware";
import { deleteSaga } from "./sagas/deleteSaga";
import { extractStammdatenSaga } from "./sagas/extractStammdatenSaga";
import { injectKeyAndClientSaga } from "./sagas/injectKeyAndClientSaga";
import { openStammdatenSaga } from "./sagas/openStammdatenSaga";

const stammdatenModule = (): Module => ({
	id: "stammdatenModule",
	views: () => viewComponentProvider,
	sagas: () => [extractStammdatenSaga, openStammdatenSaga, deleteSaga, injectKeyAndClientSaga],
	dataProviders: () => [],
	middlewares: () => [setStammdatenReadonlyMiddleware]
});

const components: { [name: string]: React.ComponentType<View> | undefined } = {
	StammdatenOverviewEngine,
	StammdatenFormEngine,
	CustomLoeschenContainer
};

function viewComponentProvider(name: string) {
	return components[name];
}

export default stammdatenModule;
